export function DiscoverShareCard({ href }: { href: string }) {
  return null;
}
